<template>
	<div class="panel_shouyin">
		<div class="listLine">
			<el-table class="table" :data="list" style="width: 100%;padding:0 0px;">
				<el-table-column prop="name" label="单号" >
					<template slot-scope="scope">
						{{scope.row.no}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="类型" width="200">
					<template slot-scope="scope">
						{{getOrderType(scope.row.order_type_id)}}
					</template>
				</el-table-column>
				<el-table-column label="生成时间" width="250">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.create_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="create_manager_name" label="创建人" width="250">
				</el-table-column>
				<!-- <el-table-column prop="remark" label="状态" width="160">
					<template slot-scope="scope">
						<span v-if="$public.FAge(scope.row.create_time)[2]">{{$public.FAge(scope.row.create_time)[2]}}天</span>
						{{$public.FAge(scope.row.create_time)[3]}}小时
						{{$public.FAge(scope.row.create_time)[4]}}分钟
					</template>
				</el-table-column> -->
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)" size="small">查看</el-button>
					</template>
				</el-table-column>
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<saleRecordSee v-if="drawerActivitySee_state" :curItem="curItem" @submit="submit_drawerActivitySee"></saleRecordSee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import saleRecordSee from "../drawer/saleRecordSee.vue"
	export default {
		components:{page,saleRecordSee},
		data(){
			return{
				list:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerActivitySee_state:false,
				curItem:{}
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		watch:{
			curPetInfo(){
				this.getList()
			}
		},
		mounted(){
			this.getList();
		},
		methods: {
			see(row){
				this.curItem=row;
				this.drawerActivitySee_state = true;
			},
			submit_drawerActivitySee(){
				this.drawerActivitySee_state = false;
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getList();
			},
			// 获取表格数据
			getList() {
				let loading = this.$loading();
				let params = {
					pet_id:this.curPetId,
					state:'3,-3,-4',
					order_type_id:'1', // 订单类型  1. 商品  2.洗美  3.病例 4. 疫苗驱虫 5.医疗服务  6 寄养   7 挂号  8 活体  9 虚拟类
					pay_type:'',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				this.$http.post('/api/Order/OrderList', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.list = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			getOrderType(i){
				if(i===1){return '消费'}
				else if(i===2){return '洗美'}
				else if(i===3){return '病例'}
				else if(i===4){return '疫苗驱虫'}
				else if(i===5){return '医疗服务'}
				else if(i===6){return '寄养'}
				else if(i===7){return '挂号'}
				else if(i===8){return '活体'}
				else if(i===9){return '虚拟类'}
				else{return ''}
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;padding:0px 0 0;box-sizing: border-box;position: relative;
	// .titleLine{
	// 	width:100%;
	// 	background-color: #fff;
	// 	height: 44px;
	// 	line-height: 30px;
	// 	padding:8px 8px;
	// 	box-sizing: border-box;
	// 	margin-bottom: 4px;
	// }
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
